import React, { useEffect, useState } from 'react';
import { Row, Col, Collapse, Pagination } from 'antd';
import { UpOutlined } from '@ant-design/icons';
import { testStat } from '../../services/testApi';

interface ProfileStatItem {
  name: string;
  date: string;
  attemptsCount: number;
}

interface ProfileStatData {
  success: ProfileStatItem[];
  uniqueSuccessCount: number;
  totalSuccessAttempts: number;
}

interface Stat {
    userData: {
        balance: number;
        extraData: { points: number },
        type: number,
    }
}

const ProfileStat: React.FC<Stat> = (props) => {
  const pageSize = 5;
  const [stat, setStat] = useState<ProfileStatData>({
    success: [],
    uniqueSuccessCount: 0,
    totalSuccessAttempts: 0,
  });
  const [successPage, setSuccessPage] = useState(1);
  useEffect(() => {
    testStat().then(result => {
      setStat({
        success: result.success ?? [],
        uniqueSuccessCount: result.uniqueSuccessCount ?? 0,
        totalSuccessAttempts: result.totalSuccessAttempts ?? 0,
      });
    });
  }, []);

  const successPageChange = (page: number) => {
    setSuccessPage(page)
  }

  const { balance, extraData, type } = props.userData;
  return (
    <div >
      <Row style={{ padding: '14px 20px' }}>
        <Col xs={12} sm={12} xl={12} xxl={8}><b>Успешно пройдено тестов:</b></Col>
        <Col xs={12} sm={12} xl={2} style={{ textAlign: 'right' }}>{stat.uniqueSuccessCount}</Col>
      </Row>
      <Row style={{ padding: '0 20px 14px' }}>
        <Col span={24} style={{ color: '#4B5563' }}>
          Всего успешных попыток: {stat.totalSuccessAttempts}
        </Col>
      </Row>
      <Row style={{ padding: '14px 20px', marginBottom: 15 }}>
        <Col xs={12} sm={12} xl={12} xxl={8}><b>Доступно баллов:</b></Col><Col xs={12} sm={12} xl={2} style={{ textAlign: 'right' }}> {type === 1 ? extraData.points : balance}</Col>
      </Row>
      <Collapse
        className='profile-stat-collapse'
        expandIconPosition='end'
        bordered={false}
        style={{ background: '#DCFCE7' }}
        defaultActiveKey={[1]}
        expandIcon={({ isActive }) => <UpOutlined rotate={isActive ? 0 : 180} style={{ fontSize: 18 }} />}
        items={[{
          key: '1',
          label: `Завершены успешно: ${stat.success.length}`,
          style: { fontSize: 18, padding: '10px 12px' },
          children:
            <Row gutter={[16, 16]} style={{ padding: '14px 4%' }}>
              {stat.success.slice((successPage - 1) * pageSize, successPage * pageSize).map((x) => (
                <Col span={24} key={`${x.name}-${x.date}`}>
                  {x.name} — {x.date} {`с ${x.attemptsCount} попытки`}
                </Col>
              ))}
            </Row>
        }]}
      />
       {!!stat.success.length && <Pagination current={successPage} total={stat.success.length} pageSize={pageSize} showSizeChanger={false} style={{ textAlign: 'center', margin: '20px 0' }} onChange={successPageChange} />}
    </div>
  );
};

export default ProfileStat;